export default __webpack_public_path__ + "static/2-zombies-9c88245845d16d7077d8fd49360244ed.jpeg";